
import { getPhoneTopStyle } from '@/composables/fxwallet'
import { defineAsyncComponent, defineComponent } from 'vue'

export default defineComponent({
  components: {
    Tiger: defineAsyncComponent(() => import('../SkinSlotComponent/c/Tiger.vue')),
    TigerMachine: defineAsyncComponent(() => import('../SkinSlotComponent/c/TigerMachine.vue'))
  },
  setup () {
    const { phoneStyle } = getPhoneTopStyle()

    return {
      phoneStyle
    }
  }
})
